import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'

import AboutPagePreview from './preview-templates/AboutPagePreview'
import TourPostPreview from './preview-templates/TourPostPreview'
import BlogPostPreview from './preview-templates/BlogPostPreview'
import TrainingPagePreview from './preview-templates/TrainingPagePreview'
import ToursPagePreview from './preview-templates/ToursPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('about', AboutPagePreview)
CMS.registerPreviewTemplate('training', TrainingPagePreview)
CMS.registerPreviewTemplate('blog', BlogPostPreview)
CMS.registerPreviewTemplate('tour', TourPostPreview)
CMS.registerPreviewTemplate('tours', ToursPagePreview)
